import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { withRouter } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import CloseIcon from '@material-ui/icons/Close';

import axios from 'axios';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

import Topbar from './common/Topbar';
import BestReview from './common/BestReview';
import Footer from './common/Footer';
import NoticeSlider from './stamptour/NoticeSlider';
import EventSlider from './stamptour/EventSlider';
import MainMap from './stamptour/MainMap';
import { API_URL } from './common/Constants';
import EntryPoint from './mypage/EntryPoint';
import Emergency from './common/Emergency';
import swal from '@sweetalert/with-react';
import queryString from 'querystring';

// import { GiArrowCursor } from 'react-icons/gi';
import { ImPointDown } from 'react-icons/im';
// import TouchAppIcon from '@material-ui/icons/TouchApp';
const styles = (theme) => ({
  bg: {
    backgroundImage: 'linear-gradient( rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.1) ),url("/images/stamptour_bg.jpg")',
    // backgroundImage: 'linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.2) ),url("/images/stamptour_bg.jpg")',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    backgroundPosition: 'center bottom',
    [theme.breakpoints.down('sm')]: {
      backgroundSize: '180%',
    },
    [theme.breakpoints.down('xs')]: {
      backgroundSize: '270%',
      backgroundPosition: '50% bottom',
    },
  },
  root: {
    overflowX: 'hidden',
    overflowY: 'auto',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    // backgroundImage: 'linear-gradient( rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7) ),url("./assets/imgs/1.jpg")',
  },
  //modal
  entryPointModalContainer: {
    display: 'none',
    position: 'fixed' /* Stay in place */,
    zIndex: 1300 /* Sit on top */,
    left: 0,
    top: 0,
    width: '100vw' /* Full width */,
    height: '100vh' /* Full height */,
    overflowY: 'none' /* Enable scroll if needed */,
    //backgroundColor: 'rgb(0,0,0)' /* Fallback color */,
    backgroundColor: 'rgba(0,0,0,0.5)' /* Black w/ opacity */,
  },
  modalDiv: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  entryPointModal: {
    display: 'flex',
    margin: '0 auto',
    width: 'calc(100% - 64px)',
    maxWidth: '600px',
    backgroundColor: '#fff',
    borderRadius: '4px',
    //boxShadow: '0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%)',
  },
  modalCloseBtn: {
    width: 'calc(100% - 64px)',
    maxWidth: '600px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'flex-end',
  },

  clickMeText: {
    fontSize: '0.7em',
    fontWeight: 'normal',
  },
  clickMeIcon: { width: '0.8em', verticalAlign: 'bottom', color: '#fff' },
});

class Main extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);
    this.goToPage = this.goToPage.bind(this);
    this.closeNoticePopup = this.closeNoticePopup.bind(this);
    let param = queryString.parse(this.props.location.search.replace('?', ''));
    let tokenParam = queryString.parse(this.props.location.hash.replace('#', ''));
    this.refModal = React.createRef();
    // for Naver Login

    if (props.location.hash.indexOf('access_token') !== -1) {
      // console.log('GO Naver Callback', `${API_URL}/naverCallback?token=${tokenParam.access_token}`);
      axios
        .get(`${API_URL}/naverCallback?token=${tokenParam.access_token}`, param, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          this.snsLogin('naver', response.data.response);
        })
        .catch((err) => {
          console.log('naver error');
          console.log(err);
        })
        .finally(() => {});
    }
    this.state = {
      learnMoredialog: false,
      getStartedDialog: false,
      satellitesDialog: false,
      faqDialog: false,
      noticeDialog: false,
      welcomeMsgDialog: false,
      scoreDialog: false,
      emergencyDialog: false,
      supportDialog: false,
      programDialog: false,
      selectedReview: null,
      popup: false,
      noticePopup: '',
      //didMount: false,
      list: {
        none: [],
        seoul: [],
        gygg: [],
        incheon: [],
        gangwon: [],
        chungbuk: [],
        chungnam: [],
        daejeon: [],
        jeonbuk: [],
        gwangju: [],
        jeonnam: [],
        gyeongbuk: [],
        daegu: [],
        gyeongnam: [],
        ulsan: [],
        busan: [],
        jeju: [],
      },
    };
  }

  snsLogin(type, res) {
    let param = null;
    if (type === 'kakao') {
      param = {
        sid: '' + res.profile.id,
        st: type,
        password: '' + res.profile.id,
        name: res.profile.kakao_account.profile.nickname,
        email: res.profile.kakao_account.email,
        img: res.profile.kakao_account.profile.profile_image_url || '',
        birthday: res.profile.kakao_account.birthday || '',
        gender: res.profile.kakao_account.gender || '',
        age_range: res.profile.kakao_account.age_range || '',
      };
    } else if (type === 'google') {
      param = {
        sid: '' + res.googleId,
        st: type,
        password: '' + res.googleId,
        name: res.profileObj.name || '',
        email: res.profileObj.email,
        img: res.profileObj.imageUrl || '',
      };
    } else if (type === 'naver') {
      param = res;
      param['sid'] = '' + res.id;
      param['st'] = type;
      param['password'] = '' + res.id;
      param['name'] = res.name || '';
      param['email'] = res.email;
      param['phone'] = res.mobile || '';
      console.log(param);
    }

    if (param) {
      axios
        .post(`${API_URL}/register`, param, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          console.log('1');
          this.doLogin(param.email, '' + param.password);
        })
        .catch((err) => {
          if (err.response && err.response.status === 308) {
            console.log('2');
            if (err.response.data.obj.st !== type) {
              console.log('3');
              // 다른 sns로 이미 가입한 사람
              swal('이미 가입하신 이메일주소입니다.').then(() => {
                window.opener = 'Self';
                window.open('', '_parent', '');
                window.close(); // 일반적인 현재 창 닫기
              });
            } else {
              console.log('4');
              console.log(param.email);
              console.log(param.password);
              console.log(type);
              this.doLogin(param.email, '' + param.password, type);
            }
          }
        });
    }
  }

  doLogin(email, password, type) {
    const param = {
      email: email,
      password: password,
    };
    axios
      .post(`${API_URL}/login`, param, { headers: { Pragma: 'no-cache' } })
      .then((response) => {
        // console.log(response);
        if (response.status === 200) {
          if (response.data.success === true) {
            localStorage.setItem('st_token', response.data.token);
            localStorage.setItem('refreshToken', response.data.refreshToken);

            let buff = {
              name: response.data.userInfo.name,
              course: response.data.userInfo.course,
              stamp: response.data.userInfo.stamp,
            };

            localStorage.setItem(`loggedin`, response.data.userInfo.id);
            localStorage.setItem(`${response.data.userInfo.id}_status`, JSON.stringify(buff));

            if (this.state.stampId) {
              axios
                .get(`${API_URL}/course/qrStamp?stampId=${this.state.stampId}&courseId=${this.state.courseId}`, {
                  headers: { Pragma: 'no-cache', Authorization: `${localStorage.getItem('st_token')}` },
                })
                .then((response) => {
                  swal({
                    text: '스탬프가 발급되었습니다.',
                    button: '확인',
                  }).then(() => {
                    this.props.history.replace(`/mypage?course=${this.state.courseId}&stamp=${this.state.stampId}`);
                  });
                })
                .catch((err) => {
                  console.log(err);
                  swal({
                    text: '이미 발급된 스탬프입니다.',
                    button: '확인',
                  }).then(() => {
                    this.props.history.replace(`/mypage?course=${this.state.courseId}`);
                  });
                });
            } else {
              console.log('type', type);
              if (type === 'naver' || type === undefined) {
                if (type === 'naver' && sessionStorage.getItem('stampId')) {
                  axios
                    .get(
                      `${API_URL}/course/qrStamp?stampId=${sessionStorage.getItem('stampId')}&courseId=${sessionStorage.getItem(
                        'courseId',
                      )}`,
                      {
                        headers: { Pragma: 'no-cache', Authorization: `${localStorage.getItem('st_token')}` },
                      },
                    )
                    .then((response) => {
                      swal({
                        text: '스탬프가 발급되었습니다.',
                        button: '확인',
                      }).then(() => {
                        sessionStorage.setItem('stampId', '');
                        this.props.history.replace(
                          `/mypage?course=${sessionStorage.getItem('courseId')}&stamp=${sessionStorage.getItem('stampId')}`,
                        );
                      });
                    })
                    .catch((err) => {
                      console.log(err);
                      swal({
                        text: '이미 발급된 스탬프입니다.',
                        button: '확인',
                      }).then(() => {
                        sessionStorage.setItem('stampId', '');
                        this.props.history.replace(`/mypage?course=${sessionStorage.getItem('courseId')}`);
                      });
                    });
                } else {
                  window.opener = 'Self';
                  window.open('', '_parent', '');
                  window.close(); // 일반적인 현재 창 닫기
                  this.props.history.replace('/');
                  setTimeout(function () {
                    window.location.reload();
                  }, 100);
                }
              } else if (type === 'google') {
                this.props.history.replace('/');
                setTimeout(function () {
                  window.location.reload();
                }, 1000);
              } else {
                this.props.history.replace('/');
              }
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response.data.msg === 'PASSWORD_AUTHENTICATION_FAILURE') {
          swal({
            text: '아이디 혹은 비밀번호가 일치하지 않습니다.',
            button: '확인',
          });
          return;
        } else if (err.response.data.msg === 'USER_NOT_FOUND') {
          swal({
            text: '일치하는 가입 정보가 없습니다.',
            button: '확인',
          }).then(() => {
            if (type === 'stamptour') {
              this.setState({ email: '', password: '' });
            }
          });
          return;
        }
      });
  }

  getCodeToName(code) {
    if (code === 'seoul') {
      return '서울특별시';
    } else if (code === 'gygg') {
      return '경기도';
    } else if (code === 'incheon') {
      return '인천광역시';
    } else if (code === 'gangwon') {
      return '강원도';
    } else if (code === 'chungbuk') {
      return '충청북도';
    } else if (code === 'chungnam') {
      return '충청남도';
    } else if (code === 'jeonbuk') {
      return '전라북도';
    } else if (code === 'daejeon') {
      return '대전광역시';
    } else if (code === 'jeonbuk') {
      return '전라북도';
    } else if (code === 'gwangju') {
      return '광주광역시';
    } else if (code === 'jeonnam') {
      return '전라남도';
    } else if (code === 'gyeongbuk') {
      return '경상북도';
    } else if (code === 'daegu') {
      return '대구광역시';
    } else if (code === 'gyeongnam') {
      return '경상남도';
    } else if (code === 'ulsan') {
      return '울산광역시';
    } else if (code === 'busan') {
      return '부산광역시';
    } else if (code === 'jeju') {
      return '제주도';
    }
  }

  /* 코스 리스트 가져와서 정리 */
  sortCourseList(datas) {
    let buffs = {
      none: [],
      seoul: [],
      gygg: [],
      incheon: [],
      gangwon: [],
      chungbuk: [],
      chungnam: [],
      daejeon: [],
      jeonbuk: [],
      gwangju: [],
      jeonnam: [],
      gyeongbuk: [],
      daegu: [],
      gyeongnam: [],
      ulsan: [],
      busan: [],
      jeju: [],
    };

    for (let i = 0; i < datas.length; i++) {
      //console.log(datas[i].addr);
      if (datas[i].region === '서울특별시') {
        buffs.seoul.push(datas[i]);
      } else if (datas[i].region === '경기도') {
        buffs.gygg.push(datas[i]);
      } else if (datas[i].region === '인천광역시') {
        buffs.incheon.push(datas[i]);
      } else if (datas[i].region === '강원도') {
        buffs.gangwon.push(datas[i]);
      } else if (datas[i].region === '충청북도') {
        buffs.chungbuk.push(datas[i]);
      } else if (datas[i].region === '충청남도') {
        buffs.chungnam.push(datas[i]);
      } else if (datas[i].region === '대전광역시') {
        buffs.daejeon.push(datas[i]);
      } else if (datas[i].region === '전라북도') {
        buffs.jeonbuk.push(datas[i]);
      } else if (datas[i].region === '광주광역시') {
        buffs.gwangju.push(datas[i]);
      } else if (datas[i].region === '전라남도') {
        buffs.jeonnam.push(datas[i]);
      } else if (datas[i].region === '전라북도') {
        buffs.gyeongbuk.push(datas[i]);
      } else if (datas[i].region === '대구광역시') {
        buffs.daegu.push(datas[i]);
      } else if (datas[i].region === '경상남도') {
        buffs.gyeongnam.push(datas[i]);
      } else if (datas[i].region === '울산광역시') {
        buffs.ulsan.push(datas[i]);
      } else if (datas[i].region === '부산광역시') {
        buffs.busan.push(datas[i]);
      } else if (datas[i].region === '제주도') {
        buffs.jeju.push(datas[i]);
      }
    }

    this.setState({ list: buffs });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    return null;
  }

  componentDidMount() {
    if (
      window.screen.width < 500 ||
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i)
    ) {
      // if (!sessionStorage.getItem('_in_user_')) {
      //   this.props.history.push('/');
      // }
      this.setState({ matches: true });
    } else {
      this.setState({ matches: false });
    }

    window.sca = '01';

    axios.get(`${API_URL}/course/list`, { headers: { Pragma: 'no-cache' } }).then((res) => {
      if (res.status === 200 && res.data) {
        this.sortCourseList(res.data);
        // console.log('Completed Course List');
      }
    });
    this.checkNoticePopupBlocked();
  }

  goToPage(_move) {
    //this.props.history.push(_move);
  }

  checkNoticePopupBlocked() {
    const { cookies } = this.props;

    if (cookies.get('main_dialog') === 'true') {
      this.setState({ isNoticePopupBlocked: true });
    } else {
      this.setState({ isNoticePopupBlocked: false }, () => {
        this.getNoticePopup();
      });
    }
  }

  getNoticePopup() {
    axios
      .get(`${API_URL}/bbs/event/list`, {
        headers: { Pragma: 'no-cache' },
      })
      .then((response) => {
        if (response.data) {
          let _result = response.data.sort((a, b) => {
            return b.createdAt - a.createdAt;
          });
          let buff = [];
          if (_result && _result.length > 0) {
            for (let i = 0; i < _result.length; i++) {
              if (_result[i].showPopup === true) {
                buff.push({
                  ..._result[i],
                  isNoticePopupOpen: true,
                });
              }
            }
          }
          this.setState({ noticePopup: buff });
        }
      });
  }

  modalClose() {
    document.getElementById('modalContainer').style.display = 'none';
    document.body.style.overflowY = 'inherit';
    if (
      navigator.userAgent.match(/mobile/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/^(safari|(?!chrome).)*$/gi)
    ) {
      document.body.style.overflow = 'inherit';
    }
  }

  modalOpen = (data) => {
    // console.log('선택한리뷰');
    // console.log(data);
    this.setState({ selectedReview: data, popup: true });
    document.getElementById('modalContainer').style.display = 'block';
    // document.body.style.position = 'fixed';
    document.body.style.overflowY = 'hidden';
    if (
      navigator.userAgent.match(/mobile/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/^(safari|(?!chrome).)*$/gi)
    ) {
      document.body.style.overflow = 'hidden';
    }

    setTimeout((data) => {
      this.refModal.current.refreshReview();
    }, 0);
  };

  onClickReview = (data) => {
    this.modalOpen(data);
  };

  closeNoticePopup(noticeId) {
    let buff = [];
    // console.log(this.state.noticePopup);
    for (let i = 0; i < this.state.noticePopup.length; i++) {
      if (noticeId == this.state.noticePopup[i].id) {
        buff.push({
          ...this.state.noticePopup[i],
          isNoticePopupOpen: false,
        });
      } else {
        buff.push(this.state.noticePopup[i]);
      }
    }
    // console.log(buff);
    this.setState({ noticePopup: buff });
  }

  render() {
    const { classes } = this.props;
    const mainPath = {
      pathname: '/main',
    };

    return this.state.matches ? (
      //모바일
      <React.Fragment>
        <CssBaseline />
        <div className={classes.bg}>
          <Topbar currentPath={mainPath} />
          <div style={{ fontWeight: 'bold', textAlign: 'center', padding: '20px 0 0', fontSize: '1.5em', color: '#fff' }}>
            대한민국 스탬프투어 <br />
            <span className={classes.clickMeText}>클릭해보세요</span>
            <ImPointDown className={classes.clickMeIcon} />
            {/* 사측요청 : 손가락 아이콘( 아래쪽 방향 ) */}
            {/* <TouchAppIcon className={classes.clickMeIcon} /> */}
          </div>
          <MainMap list={this.state.list} />
        </div>

        <NoticeSlider />
        <EventSlider />
        <BestReview onClickReview={this.onClickReview} />

        <Footer />
        <div id={'modalContainer'} className={classes.entryPointModalContainer}>
          <div className={classes.modalDiv}>
            <div className={classes.modalCloseBtn}>
              <CloseIcon
                onClick={() => {
                  this.modalClose();
                }}
                style={{ color: '#fff', cursor: 'pointer', width: '1.5em', height: '1.5em' }}
                // style={{ position: 'absolute', right: '1em', top: '1em', cursor: 'pointer' }}
              />
            </div>
            <div className={classes.entryPointModal}>
              <EntryPoint
                ref={this.refModal}
                reviewId={this.state.selectedReview ? this.state.selectedReview.id : null}
                onClose={this.modalClose.bind(this)}
                mode={0}
                bestReview={true}
                showDialog={this.state.popup}
              />
            </div>
          </div>
        </div>
        {this.state.noticePopup &&
          this.state.noticePopup.length > 0 &&
          this.state.noticePopup.map((noticeItem, noticeIdx) => {
            // console.log(noticeItem);
            return (
              <Emergency
                open={noticeItem.isNoticePopupOpen}
                onClose={() => this.closeNoticePopup(noticeItem.id)}
                disableBackdrop={true}
                noticePopup={noticeItem}
                key={noticeIdx}
              />
            );
          })}
      </React.Fragment>
    ) : (
      // 웹
      <React.Fragment>
        <CssBaseline />
        <div className={classes.bg}>
          <Topbar currentPath={mainPath} />
          <div
            style={{ fontWeight: 'bold', textAlign: 'center', marginLeft: '-80px', padding: '20px 0 0', fontSize: '1.5em', color: '#fff' }}
          >
            대한민국 스탬프투어 <br />
            <span className={classes.clickMeText}>클릭해보세요</span>
            <ImPointDown className={classes.clickMeIcon} />
            {/* 사측요청 : 손가락 아이콘( 아래쪽 방향 ) */}
            {/* <TouchAppIcon className={classes.clickMeIcon} /> */}
          </div>
          <MainMap list={this.state.list} />
        </div>
        <NoticeSlider />
        <EventSlider />
        <BestReview onClickReview={this.onClickReview} />
        <Footer />
        <div id={'modalContainer'} className={classes.entryPointModalContainer}>
          <div className={classes.modalDiv}>
            <div className={classes.modalCloseBtn}>
              <CloseIcon
                onClick={() => {
                  this.modalClose();
                }}
                style={{ color: '#fff', cursor: 'pointer', width: '1.5em', height: '1.5em' }}
                // style={{ position: 'absolute', right: '1em', top: '1em', cursor: 'pointer' }}
              />
            </div>
            <div className={classes.entryPointModal}>
              <EntryPoint
                courseInfo={this.state.selectedReview ? this.state.selectedReview.course : null}
                ref={this.refModal}
                reviewId={this.state.selectedReview ? this.state.selectedReview.id : null}
                onClose={this.modalClose.bind(this)}
                mode={0}
                bestReview={true}
                showDialog={this.state.popup}
              />
            </div>
          </div>
        </div>
        {this.state.noticePopup &&
          this.state.noticePopup.length > 0 &&
          this.state.noticePopup.map((noticeItem, noticeIdx) => {
            // console.log(noticeItem);
            return (
              <Emergency
                open={noticeItem.isNoticePopupOpen}
                onClose={() => this.closeNoticePopup(noticeItem.id)}
                disableBackdrop={true}
                noticePopup={noticeItem}
                key={noticeIdx}
              />
            );
          })}
      </React.Fragment>
    );
  }
}

export default withCookies(withRouter(withStyles(styles)(Main)));
